import { createRoute } from '@tanstack/react-router'
import { lazy } from 'react'
import { listSearch } from '../list-search'
import type { LazyPage } from './lazy-page'
import { guardAt } from './products'
import { rootRoute } from './root'

const SongsPage: LazyPage = lazy(() =>
  import('../../routes/music/SongsPage').then((m) => ({
    default: m.SongsPage,
  })),
)
const PatternsPage: LazyPage = lazy(() =>
  import('../../routes/music/PatternsPage').then((m) => ({
    default: m.PatternsPage,
  })),
)
const SongPage: LazyPage<{ songId: string }> = lazy(() =>
  import('../../routes/music/SongPage').then((m) => ({
    default: m.SongPage,
  })),
)
const SongEditPage: LazyPage<{ songId: string }> = lazy(() =>
  import('../../routes/music/SongEditPage').then((m) => ({
    default: m.SongEditPage,
  })),
)
/* A song is read at its own address, so a sheet can be linked to and a reload
   leaves the player where they were rather than back on the shelf. */
const songsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/songs',
  beforeLoad: guardAt('/songs'),
  component: SongsPage,
  validateSearch: listSearch,
})
/* Patterns are a PAGE of the songs section rather than a view of a song, so
   they take an address of their own beneath it — and it is declared before
   `/songs/$id`, which would otherwise read `patterns` as a song's id. */
const patternsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/songs/patterns',
  beforeLoad: guardAt('/songs'),
  component: PatternsPage,
})
const songRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/songs/$id',
  beforeLoad: guardAt('/songs'),
  component: function SongRoute() {
    const { id } = songRoute.useParams()
    return <SongPage songId={id} />
  },
})
/* Correcting a song is a surface of its own rather than a state the reading
   page holds, so it has an address: a correction in progress can be linked to
   and survives a reload, and the way out is back to the song. */
const songEditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/songs/$id/edit',
  beforeLoad: guardAt('/songs'),
  component: function SongEditRoute() {
    const { id } = songEditRoute.useParams()
    return <SongEditPage songId={id} />
  },
})

export const musicRoutes = [songsRoute, patternsRoute, songRoute, songEditRoute]
